import {  CheckBox } from "devextreme-react";
import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { AdminContacts, CompleteContact } from "./type";

const AdminContactDetail = forwardRef<any, { data: AdminContacts, complete: CompleteContact }>((
    { data, complete }, ref
) => {
    const localize = useSelector(getLocalized);
    
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                label={{
                    text: localize.getString("name"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Surname"}
                label={{
                    text: localize.getString("surname"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Phone"}
                label={{
                    text: localize.getString("phone"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Email"}
                label={{
                    text: localize.getString("email"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Message"}
                label={{
                    text: localize.getString("message"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"IsCompleted"}

                label={{
                    text: localize.getString("isComplated"),
                }}
                render={(e: any) => {
                    return <CheckBox
                        value={data.IsComplated}
                        disabled={true}
                    ></CheckBox>
                }}
            >

            </SimpleItem>
         
        </GroupItem>
    </Form>
})

export default AdminContactDetail;